var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import CreateCategoryModal from "./createCategoryModal";
import AvisoDiv from "../shared/div";
import AvisoLayout from "../shared/layout";
import SEO from "../../src/View/UI/SEO/SEO";
import FAIcon from "../../src/View/UI/FAIcon/FAIcon";
class Categories extends PureComponent {
    constructor(props) {
        super(props);
        this.fetchCategories = this.fetchCategories.bind(this);
        this.setCurrentCategory = this.setCurrentCategory.bind(this);
        this.renderCategory = this.renderCategory.bind(this);
        this.goToCategory = this.goToCategory.bind(this);
        this.renderNav = this.renderNav.bind(this);
        this.search = this.search.bind(this);
        this.state = {
            loading: true,
            categories: [],
            searchCategories: [],
            totalCount: 0,
            currentCategory: null,
            goToCategory: null,
            searchValue: "",
            canManage: false,
            errorMessage: "",
        };
    }
    componentDidMount() {
        this.fetchCategories();
    }
    goToCategory(id) {
        this.setState({ goToCategory: id });
    }
    fetchCategories(term = "") {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ loading: true });
            const response = yield fetch(`/aviso/resourceGuide/getCategories?term=${term}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const result = yield response.json();
            if (!result.success) {
                if (result.data &&
                    typeof result.data.isUser !== "undefined" &&
                    !result.data.isUser) {
                    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Location'.
                    window.location = window.location.href.replace("category", "categoryAuth");
                }
                if (result.data &&
                    typeof result.data.message !== "undefined" &&
                    result.data.message) {
                    this.setState({ loading: false, errorMessage: result.data.message });
                }
                if (result.message) {
                    this.setState({ loading: false, errorMessage: result.message });
                }
                else {
                    this.setState({
                        loading: false,
                        errorMessage: "There was an error loading this resource. Please reload and try again.",
                    });
                }
                return;
            }
            const { data: categories, totalCount, canManage } = result;
            categories.reverse();
            this.setState({
                categories,
                searchCategories: categories.filter((category) => category.name.includes(this.state.searchValue)),
                totalCount,
                canManage,
                loading: false,
            });
        });
    }
    renderResourceLink(resource, category) {
        return (_jsx("li", { children: _jsx(Link, { className: "list-group-item", to: `/aviso/app/resourceGuide/category/${category.id}/resource/${resource.id}/details`, children: resource.name }) }, resource.id));
    }
    search(event) {
        this.setState({
            searchValue: event.target.value,
            searchCategories: this.state.categories.filter((category) => category.name
                .toLowerCase()
                .includes(event.target.value.toLowerCase().trim())),
        });
    }
    renderBadge(active) {
        if (!active) {
            return (_jsx("small", { className: "badge badge-pill badge-danger float-right", children: "Inactive" }));
        }
        return (_jsx("small", { className: "badge badge-pill badge-success float-right", children: "Active" }));
    }
    renderNav() {
        return (_jsxs("div", { className: "d-flex justify-content-between align-items-center w-100 h-100", children: [_jsx("div", { children: _jsx(AvisoDiv, { show: this.state.canManage, children: _jsxs("button", { className: "btn btn-link", "data-target": "#createCategoryModal", "data-toggle": "modal", onClick: () => this.setState({ currentCategory: null }), title: "New Category", children: [_jsx(FAIcon, { icon: "plus", addMarginRight: true }), _jsx("span", { className: "d-none d-md-inline-block", children: "New Category" }), _jsx("span", { className: "sr-only", children: "New Category" })] }) }) }), _jsx("div", { children: _jsxs("div", { className: "input-group", children: [_jsx("input", { autoComplete: "off", autoCorrect: "off", className: "form-control", id: "search-input", onChange: this.search, placeholder: "Search Categories", spellCheck: "false", type: "text", value: this.state.searchValue, "aria-label": "Search Categories" }), _jsx("div", { className: "input-group-append input-group-append-blend", children: _jsx("button", { type: "button", className: "btn btn-outline-secondary", "aria-label": "Search", children: _jsx("span", { className: "fal fa-search" }) }) })] }) })] }));
    }
    renderCategory(category) {
        return (_jsx("div", { className: "card mb-3", children: _jsxs("div", { className: "card-body d-flex justify-content-between", children: [_jsxs("div", { children: [_jsx(Link, { to: `/aviso/app/resourceGuide/category/${category.id}`, children: _jsx("h2", { className: "h4", children: category.name }) }), _jsx("div", { children: _jsx("small", { className: "text-muted", children: `${category.resourceCount} ${category.resourceCount === 1 ? "Resource" : "Resources"}` }) })] }), _jsxs("div", { className: "d-flex align-items-center", children: [_jsx(AvisoDiv, { show: this.state.canManage, children: _jsx("div", { className: "pr-2", children: this.renderBadge(category.active) }) }), _jsx(AvisoDiv, { show: this.state.canManage, children: _jsx("button", { title: "Edit", className: "btn btn-link", "data-target": "#createCategoryModal", "data-toggle": "modal", onClick: (e) => this.setCurrentCategory(category), children: _jsx(FAIcon, { icon: "pencil-alt", type: "far" }) }) })] })] }) }, category.id));
    }
    setCurrentCategory(category) {
        this.setState({ currentCategory: category });
    }
    render() {
        if (this.state.goToCategory) {
            return (_jsx(Redirect, { to: `/aviso/app/resourceGuide/category/${this.state.goToCategory}` }));
        }
        return (_jsxs(AvisoLayout, { renderNav: this.renderNav, children: [_jsx(SEO, { title: "Resource Guide" }), _jsx(AvisoDiv, { isLoading: this.state.loading, error: !!this.state.errorMessage, errorMessage: this.state.errorMessage, children: _jsxs("div", { children: [_jsx("h1", { children: "Resource Guide" }), _jsx("div", { className: "my-3", children: _jsx("div", { className: "list-group mb-3", children: this.state.searchCategories.map(this.renderCategory) }) })] }) }), _jsx(CreateCategoryModal, { category: this.state.currentCategory, id: "createCategoryModal", onSaveSuccess: this.goToCategory })] }));
    }
}
export default Categories;
